const Jumbotron = (props) =>
    <div className="rounded-lg border bg-white dark:border-gray-500 dark:bg-gray-800 shadow-sm" {...props}/>

export default Jumbotron;